import React from 'react';
import { useSiteConfig } from '../hooks/useSiteConfig';
import Editable from './Editable';
import './Footer.css';

const DEFAULT_FOOTER = {
  tagline: 'Find meaningful, one-of-a-kind pieces perfect for gifting or adding a personal touch to your home.',
  copyright_name: 'Kalsies Creations',
};

const DEFAULT_CONTACT = {
  email: 'loganccurtis@gmail.com',
  phone: '(307) 409-2600',
};

export default function Footer() {
  const { config } = useSiteConfig();
  const footer = config.footer || DEFAULT_FOOTER;
  const contact = config.contact || DEFAULT_CONTACT;
  const year = new Date().getFullYear();
  const email = contact.email || DEFAULT_CONTACT.email;
  const phone = contact.phone || DEFAULT_CONTACT.phone;
  const tagline = footer.tagline || DEFAULT_FOOTER.tagline;
  const copyrightName = footer.copyright_name || DEFAULT_FOOTER.copyright_name;

  return (
    <Editable descriptor={{ kind: 'config', key: 'footer', label: 'Site footer' }}>
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Kalsies Creations/California Handcraft</h3>
          <p>{tagline}</p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/portfolio">Portfolio</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact</h4>
          {email && <p>Email: <a href={`mailto:${email}`}>{email}</a></p>}
          {phone && <p>Phone: <a href={`tel:${String(phone).replace(/[^+\d]/g, '')}`}>{phone}</a></p>}
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {year} {copyrightName}. All rights reserved. <a href="/admin" style={{ color: 'inherit', opacity: 0.6, marginLeft: 8 }}>Admin</a></p>
      </div>
    </footer>
    </Editable>
  );
}
